import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BASE_URL, PagedResponse } from '@edl-development/edl-common';
import { PaetepApi } from '../paetep/paetep.api';
import { PagedModel } from 'src/app/model/base/paged.model';
import { CustomFormSummaryDTO } from 'src/app/model/observation/custom-forms/builder/custom-form-summary-dto.model';
import { CustomFormBuilderDTO } from 'src/app/model/observation/custom-forms/custom-form-builder-dto.model';
import { CustomFormDisplayDTO } from 'src/app/model/observation/custom-forms/custom-form-display-dto.model';
import { CustomFormBuilderDetailsDTO } from 'src/app/model/observation/custom-forms/builder/custom-form-builder-details-dto.model';
import { UserFormSelectorDTO } from 'src/app/model/observation/custom-forms/builder/user-form-selector-dto.model';
import { CustomFormDuplicateDTO } from 'src/app/model/observation/custom-forms/custom-form-duplicate-dto.model';

@Injectable()
export class CustomFormBuilderApi extends PaetepApi {

    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    getCustomForms(paging: PagedModel) {
        const params = this.generatePagingParams(paging);
        
        return this.http.get<PagedResponse<CustomFormSummaryDTO>>(`${this.baseUri}/observation/customFormBuilder/GetCustomForms`, { params });
    }

    getUsageReport = (formID: string, paging: PagedModel) => {
        const params = this.generatePagingParams(paging);
        
        return this.http.get<PagedResponse<UserFormSelectorDTO>>(`${this.baseUri}/observation/customFormBuilder/GetCustomFormUsageReport/${formID}`, { params });
    }

    downloadAllUserData(formID: string) {
        return this.http.get(`${this.baseUri}/observation/customFormBuilder/DownloadAllUserData/${formID}`, {
            responseType: 'blob'
        });
    }

    getCustomForm(formId: string) {
        return this.http.get<CustomFormBuilderDetailsDTO>(`${this.baseUri}/observation/customFormBuilder/GetCustomForm/${formId}`);
    }

    createCustomForms(form: CustomFormBuilderDTO) {
        return this.http.post<CustomFormDisplayDTO>(`${this.baseUri}/observation/customFormBuilder/create`, form);
    }

    saveCustomForms(form: CustomFormBuilderDTO) {
        return this.http.put<CustomFormDisplayDTO>(`${this.baseUri}/observation/customFormBuilder/save`, form);
    }

    submitCustomForms(form: CustomFormBuilderDTO) {
        return this.http.put<CustomFormDisplayDTO>(`${this.baseUri}/observation/customFormBuilder/submit`, form);
    }

    duplicateCustomForms(duplicateDTO: CustomFormDuplicateDTO) {
        return this.http.post<CustomFormDisplayDTO>(`${this.baseUri}/observation/customFormBuilder/duplicate`, duplicateDTO);
    }

    convertToTemplate(duplicateDTO: CustomFormDuplicateDTO) {
        return this.http.post<CustomFormDisplayDTO>(`${this.baseUri}/observation/customFormBuilder/convertToTemplate`, duplicateDTO);
    }

    archiveCustomForms(formId: string) {
        return this.http.put<CustomFormDisplayDTO>(`${this.baseUri}/observation/customFormBuilder/archive/${formId}`, {});
    }

    activateCustomForms(formId: string) {
        return this.http.put<CustomFormDisplayDTO>(`${this.baseUri}/observation/customFormBuilder/activate/${formId}`, {});
    }

    deleteCustomForms(formId: string) {
        return this.http.put<CustomFormDisplayDTO>(`${this.baseUri}/observation/customFormBuilder/delete/${formId}`, {});
    }

    restoreCustomForms(formId: string) {
        return this.http.put<CustomFormDisplayDTO>(`${this.baseUri}/observation/customFormBuilder/restore/${formId}`, {});
    }
}